import ConfigurationHelper from '../../../helpers/ConfigurationHelper/ConfigurationHelper'

export const getSeoSettings = (locale: string, router: any = null) => {
  const globalConfiguration = ConfigurationHelper.getConfiguration('default_page_title', router)
  const defaultData: any =  {
    title: globalConfiguration,
    localeTerritory: `${locale}_${locale.toUpperCase()}`,
  }
  switch (locale) {
    case 'en':
      defaultData.baseTitle = 'LilouParis Online Shop'
      return defaultData
    case 'de':
      defaultData.baseTitle = 'LilouParis Online-Shop'
      return defaultData
    case 'fr':
      defaultData.baseTitle = 'Boutique en ligne Lilou'
      return defaultData
    default:
      defaultData.baseTitle = 'Sklep Lilou'
      return defaultData
  }
}